import createReducer from '../createReducer';
import {
  CREATE_CONFIGURATION,
  CREATE_CONFIGURATION_FINISH,
  UPDATE_NEW_CONFIGURATION,
  REDIRECT_CONFIGURATION,
  UPDATE_ERRORS,
} from '../actions/newConfiguration';
import { CONFIGURATION_TYPES, PLATFORMS } from '../../constants/configurations';

const { countryName, countryCode2, countryCode3, currency, salesOrg } =
  JSON.parse(localStorage.getItem('country')) || {};

const platform = localStorage.getItem('platform');
const type = localStorage.getItem('type');

export const initialState = {
  newConfigurationData: {
    platform: Object.values(PLATFORMS).indexOf(platform) > -1 ? platform : PLATFORMS.QRADAR,
    type:
      type === CONFIGURATION_TYPES.UPGRADE.value && platform == PLATFORMS.QRADAR ? type : CONFIGURATION_TYPES.NEW.value,
    ...{ country: countryName, countryCode2, countryCode3, currency, salesOrg },
  },
  creatingConfiguration: false,
  redirect: false,
  errors: {},
};

export default createReducer(initialState, {
  [CREATE_CONFIGURATION]: draft => {
    draft.creatingConfiguration = true;
  },

  [CREATE_CONFIGURATION_FINISH]: draft => {
    const { countryName, countryCode2, countryCode3, currency, salesOrg } =
      JSON.parse(localStorage.getItem('country')) || {};
    draft.creatingConfiguration = false;
    draft.errors = {};
    draft.newConfigurationData = {
      platform: localStorage.getItem('platform') || null,
      type: localStorage.getItem('type') || null,
      ...{ country: countryName, countryCode2, countryCode3, currency, salesOrg },
    };
  },

  [UPDATE_NEW_CONFIGURATION]: (draft, action) => {
    draft.newConfigurationData = action.newConfigurationData;
  },

  [REDIRECT_CONFIGURATION]: draft => {
    draft.redirect = true;
  },

  [UPDATE_ERRORS]: (draft, action) => {
    draft.errors = action.errors;
  },
});
